import { defineMessages, type IntlShape } from 'react-intl';
import logError from '@alltrails/core/utils/logError';
import ExploreServiceSort from '../types/ExploreServiceSort';

type BaseSortType = Extract<ExploreServiceSort, 'best_match' | 'closest' | 'most_popular' | 'newly_added' | 'seasonal'>;

const messages = defineMessages<BaseSortType>({
  best_match: {
    defaultMessage: 'Most relevant'
  },
  closest: {
    defaultMessage: 'Closest'
  },
  most_popular: {
    defaultMessage: 'Most popular'
  },
  newly_added: {
    defaultMessage: 'Newly added'
  },
  seasonal: {
    defaultMessage: 'By month'
  }
});

export default function getExploreServiceSortLabel(intl: IntlShape, sort: ExploreServiceSort): string {
  // Default to the best-match label when sort is undefined
  if (!sort || sort === 'best_match') {
    return intl.formatMessage(messages.best_match);
  }

  // For month-specific sorts (month_1 through month_12), show "By month"
  if (sort.startsWith('month_')) {
    return intl.formatMessage(messages.seasonal);
  }

  const message = messages[sort as BaseSortType];

  if (message) {
    return intl.formatMessage(message);
  }

  logError(new Error(`Unknown sort: ${sort}`));
  return '';
}
